import React from "react";
import Character1Pool from "./Character1Pool.js"
import Character2Pool from "./Character2Pool.js"
import Character3Pool from "./Character3Pool.js"
import Character4Pool from "./Character4Pool.js"

class CharacterPool extends React.Component {
  state = { svg: null };

  componentDidMount() {
    const svgSupport =
      !!document.createElementNS &&
      !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
        .createSVGRect;
    if (svgSupport) {
      this.setState({
        svg: "svg"
      });
    } else {
      this.setState({
        svg: "png"
      });
    }
  }

  render() {
    return (
      <div
        className={
          "option character-illustration-wrapper character-pool " +
          this.state.svg
        }
      >
        {this.props.characterReference === "character-1" && <Character1Pool/>}
        {this.props.characterReference === "character-2" && <Character2Pool/>}
        {this.props.characterReference === "character-3" && <Character3Pool/>}
        {this.props.characterReference === "character-4" && <Character4Pool/>}
        <svg className={"character-background character-pool-background"} />
      </div>
    );
  }
}

export default CharacterPool;
